<div uvxRegisterIcon>
    <router-outlet></router-outlet>
</div>
